export default "__VITE_ASSET__DmbW5hVt__"